import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import {
  emptyStateIconWrap,
  paginationCount,
  paginationFooter,
  toolbar,
  toolbarFilters,
} from "@/components/Templates/Page/ListPage.styles";

export {
  toolbar,
  toolbarFilters,
  paginationFooter,
  paginationCount,
  emptyStateIconWrap,
};

export const pageStack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(2), md: theme.spacing(3) },
});

export const desktopHeader: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
};

export const mobileHeader: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  alignItems: "center",
  justifyContent: "space-between",
};

export const mobileHeaderText: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.375,
};

export const mobileTitle: SxProps<Theme> = {
  fontSize: "1.25rem",
  fontWeight: 700,
  lineHeight: 1.2,
};

export const mobileCountLabel: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  lineHeight: 1.5,
};

export const mobileCreateButton: SxProps<Theme> = (theme) => ({
  boxShadow: `0 10px 20px ${alpha(theme.palette.primary.dark, 0.25)}`,
});

export const desktopSearchWrap: SxProps<Theme> = {
  width: 300,
  maxWidth: "100%",
};

export const mobileStack: SxProps<Theme> = (theme) => ({
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  gap: theme.spacing(2),
});

export const mobileFiltersRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  overflowX: "auto",
  pb: 0.25,
  flexWrap: "nowrap",
  WebkitOverflowScrolling: "touch",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

export const emptyActionWrap: SxProps<Theme> = {
  mt: 1.75,
};

export const emptyDescription: SxProps<Theme> = {
  maxWidth: 380,
  lineHeight: 1.8,
};

export const mobileEmptyState: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  textAlign: "center",
  py: 7.5,
  px: 1.5,
};

export const mobileEmptyIconWrap: SxProps<Theme> = (theme) => ({
  width: 96,
  height: 96,
  borderRadius: 3.25,
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 1,
});

export const mobileEmptyTitle: SxProps<Theme> = {
  fontSize: "1.03125rem",
  fontWeight: 700,
  lineHeight: 1.3,
};

export const mobileEmptyDescription: SxProps<Theme> = {
  maxWidth: 260,
  lineHeight: 1.8,
  fontSize: "0.78125rem",
  color: "text.secondary",
};

export const mobileEmptyButton: SxProps<Theme> = (theme) => ({
  minWidth: 0,
  width: "auto",
  height: 46,
  px: 2.75,
  mt: 1.75,
  borderRadius: 1.5,
  fontSize: "0.875rem",
  fontWeight: 700,
  boxShadow: `0 10px 20px ${alpha(theme.palette.primary.dark, 0.25)}`,
});

export const desktopContentCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2.75,
  boxShadow: theme.shadows[3],
  p: theme.spacing(2.75, 3),
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  gap: 2.25,
});

export const desktopEmptyStateCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2.75,
  boxShadow: theme.shadows[3],
  p: theme.spacing(8, 3),
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  textAlign: "center",
  minHeight: 440,
});
